export default __webpack_public_path__ + "static/media/Snd_ClowerQ.86e04900.mp3";